import { useMemo } from "react";
import { Breadcrumb } from "@fluentui/react";
import { useNavigateEv2Experiments } from "../Hooks/UseNavigateToEv2Experiments";
import { useEv2ExperimentParams } from "../Hooks/UseCurrentExtension";
import useAppInsights from "../Hooks/UseAppInsights";
import { NavType } from "./AppInsights";
interface BreadcrumbsProps {
  isClone: boolean;
  isCreate: boolean;
  secondBreadcrumb?: string;
}

/**
 * Renders breadcrumbs for experiment navigation. When isCreate is true, shows "Create Experiment".
 * When isClone is true, shows "Clone Experiment". Otherwise, shows the experiment name.
 */
const ExperimentBreadcrumbs: React.FC<BreadcrumbsProps> = ({
  isClone,
  isCreate,
  secondBreadcrumb,
}) => {
  const { trackNavigationEvent } = useAppInsights("ExperimentBreadcrumbs");
  const { experimentName } = useEv2ExperimentParams();
  const { navigateToRoot } = useNavigateEv2Experiments();

  const breadcrumbItems = useMemo(() => {
    return [
      {
        text: "Experiments",
        key: "experiments",
        onClick: () => {
          navigateToRoot();
          trackNavigationEvent({
            destination: "ExperimentsTable",
            navType: NavType.Internal,
          });
        },
        "aria-label": "Experiments",
      },
      {
        text: isClone
          ? "Clone Experiment"
          : isCreate
            ? "Create Experiment"
            : secondBreadcrumb || experimentName || "Experiment",
        key: isClone
          ? "cloneExperiment"
          : isCreate
            ? "createExperiment"
            : secondBreadcrumb || experimentName || "experiment",
        isCurrentItem: true,
      },
    ];
    // eslint-disable-next-line react-hooks/exhaustive-deps --- ignore tracking event
  }, [experimentName, isClone, isCreate, navigateToRoot, secondBreadcrumb]);

  const breadcrumbStyles = {
    itemLink: {
      fontSize: "15px",
    },
    item: {
      fontSize: "15px",
      marginBottom: "1px",
    },
    chevron: {
      marginTop: "3px",
    },
  };

  return (
    <Breadcrumb
      dividerAs={() => <span>/</span>}
      items={breadcrumbItems}
      styles={breadcrumbStyles}
    />
  );
};

export default ExperimentBreadcrumbs;
